import { event } from 'vue-gtag'
/**

      1) 우리은행 Bank Code
        - Bank > Bank Account 메뉴 :  hb_bank_menu
        - Bank > 계좌개설 이벤트 보기  :  hb_new_account
        - Bank > 계좌이체 이벤트 보기  :  hb_bank_transfer

      2) 우리카드 Card Code
        - Card > 배너 클릭  : hb_card_banner
        - Card > 신청하기  :  hb_new_card
        - Card > 우리카드 배너  : hb_wcard_banner
        - Register Card  :  hb_register_card
 */
export default function useGTag () {
    const trackEvent = (eventName) => {
        event(eventName, { ga_code: eventName })
    }
    return { trackEvent }
}
